import React from 'react';
import {Link} from 'react-router-dom';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { trackButtonClick } from '../utils/tracking';

const {FiClock,FiUser,FiArrowRight}=FiIcons;

const BlogPage=()=> {
  const blogPosts=[
    {id: 'pet-insurance-worth-it',title: 'Is Pet Insurance Worth It? Complete 2024 Guide',excerpt: 'Discover if pet insurance is a smart investment for your furry friend. Learn about costs,benefits,and real-world scenarios.',category: 'Guide',readTime: '8 min',date: 'December 15,2024',image: 'https://images.unsplash.com/photo-1548199973-03cce0bbc87b?w=400&h=250&fit=crop'},
    {id: 'best-pet-insurance-companies',title: 'Best Pet Insurance Companies in 2024: Complete Comparison',excerpt: 'Compare top-rated pet insurance providers,coverage options,and pricing to find the perfect plan for your pet.',category: 'Comparison',readTime: '12 min',date: 'December 12,2024',image: 'https://images.unsplash.com/photo-1576201836106-db1758fd1c97?w=400&h=250&fit=crop'},
    {id: 'dog-insurance-complete-guide',title: 'Dog Insurance: Everything You Need to Know',excerpt: 'Comprehensive guide to dog insurance coverage,costs,and what to look for when choosing a policy.',category: 'Dogs',readTime: '10 min',date: 'December 10,2024',image: 'https://images.unsplash.com/photo-1552053831-71594a27632d?w=400&h=250&fit=crop'},
    {id: 'cat-insurance-guide',title: 'Cat Insurance: Protecting Your Feline Friend',excerpt: 'Learn about cat-specific insurance needs,coverage options,and why indoor cats need protection too.',category: 'Cats',readTime: '9 min',date: 'December 8,2024',image: 'https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?w=400&h=250&fit=crop'},
    {id: 'pre-existing-conditions-pet-insurance',title: 'Pet Insurance and Pre-Existing Conditions: What\'s Covered?',excerpt: 'Understanding how pre-existing conditions affect pet insurance coverage and your options.',category: 'Coverage',readTime: '7 min',date: 'December 6,2024',image: 'https://images.unsplash.com/photo-1583337130417-3346a1be7dee?w=400&h=250&fit=crop'},
    {id: 'pet-insurance-cost-breakdown',title: 'Pet Insurance Cost: Complete Pricing Guide for 2024',excerpt: 'Break down pet insurance costs by breed,age,location,and coverage type to budget effectively.',category: 'Pricing',readTime: '11 min',date: 'December 4,2024',image: 'https://images.unsplash.com/photo-1450778869180-41d0601e046e?w=400&h=250&fit=crop'},
    {id: 'senior-pet-insurance',title: 'Senior Pet Insurance: Coverage for Older Dogs and Cats',excerpt: 'Special considerations for insuring senior pets,including coverage options and cost factors.',category: 'Senior Pets',readTime: '8 min',date: 'December 2,2024',image: 'https://images.unsplash.com/photo-1601758228041-f3b2795255f1?w=400&h=250&fit=crop'},
    {id: 'pet-insurance-dental-coverage',title: 'Pet Insurance with Dental Coverage: What You Need to Know',excerpt: 'Comprehensive guide to dental coverage in pet insurance and why oral health matters.',category: 'Dental',readTime: '6 min',date: 'November 30,2024',image: 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=400&h=250&fit=crop'},
    {id: 'pet-insurance-wellness-plans',title: 'Pet Insurance vs Wellness Plans: Which is Right for You?',excerpt: 'Compare traditional pet insurance with wellness plans and preventative care coverage.',category: 'Wellness',readTime: '9 min',date: 'November 28,2024',image: 'https://images.unsplash.com/photo-1516734212186-a967f81ad0d7?w=400&h=250&fit=crop'},
    {id: 'exotic-pet-insurance',title: 'Insurance for Birds,Rabbits,and Exotic Pets',excerpt: 'Specialized coverage options for exotic pets including birds,rabbits,reptiles,and small mammals.',category: 'Exotic Pets',readTime: '7 min',date: 'November 26,2024',image: 'https://images.unsplash.com/photo-1452570053594-1b985d6ea890?w=400&h=250&fit=crop'},
    {id: 'pet-insurance-waiting-periods',title: 'Pet Insurance Waiting Periods: What You Need to Know',excerpt: 'Understanding waiting periods,coverage start dates,and options for immediate coverage.',category: 'Coverage',readTime: '5 min',date: 'November 24,2024',image: 'https://images.unsplash.com/photo-1551717743-49959800b1f6?w=400&h=250&fit=crop'},
    {id: 'how-pet-insurance-works',title: 'How Pet Insurance Works: A Complete Beginner\'s Guide',excerpt: 'Step-by-step guide to understanding pet insurance,claims process,and reimbursement.',category: 'Guide',readTime: '10 min',date: 'November 22,2024',image: 'https://images.unsplash.com/photo-1415369629372-26f2fe60c467?w=400&h=250&fit=crop'},
    {id: 'multiple-pet-insurance-discounts',title: 'Multi-Pet Insurance Discounts: Save on Multiple Pets',excerpt: 'How to save money when insuring multiple pets with family discounts and bundled coverage.',category: 'Savings',readTime: '6 min',date: 'November 20,2024',image: 'https://images.unsplash.com/photo-1522276498395-f4f68f7f8454?w=400&h=250&fit=crop'},
    {id: 'puppy-kitten-insurance',title: 'Puppy and Kitten Insurance: Early Protection Benefits',excerpt: 'Why early enrollment matters and special considerations for young pets.',category: 'Young Pets',readTime: '8 min',date: 'November 18,2024',image: 'https://images.unsplash.com/photo-1583511655857-d19b40a7a54e?w=400&h=250&fit=crop'},
    {id: 'pet-insurance-deductibles',title: 'Understanding Pet Insurance Deductibles and Reimbursement',excerpt: 'How deductibles work,annual vs per-incident options,and choosing the right reimbursement level.',category: 'Coverage',readTime: '7 min',date: 'November 16,2024',image: 'https://images.unsplash.com/photo-1559190394-df5a28aab5c5?w=400&h=250&fit=crop'}
  ];
  const categories=['All','Guide','Coverage','Dogs','Cats','Comparison','Pricing','Wellness'];
  const [selectedCategory,setSelectedCategory]=React.useState('All');
  const filteredPosts=selectedCategory==='All' ? blogPosts : blogPosts.filter(post=> post.category===selectedCategory);

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Pet Insurance Blog
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Expert insights,guides,and tips to help you make the best decisions for your pet's health and insurance coverage.
          </p>
        </motion.div>

        {/* Category Filter */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="flex flex-wrap justify-center gap-4 mb-12"
        >
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-6 py-2 rounded-full font-medium transition-colors ${
                selectedCategory === category
                  ? 'bg-blue-600 text-white'
                  : 'bg-white text-gray-700 hover:bg-blue-50 hover:text-blue-600'
              }`}
            >
              {category}
            </button>
          ))}
        </motion.div>

        {/* Blog Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredPosts.map((post,index) => (
            <motion.article
              key={post.id}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow"
            >
              <img src={post.image} alt={post.title} className="w-full h-48 object-cover" />
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className="bg-blue-100 text-blue-800 text-sm font-medium px-2.5 py-0.5 rounded">
                    {post.category}
                  </span>
                  <div className="flex items-center text-sm text-gray-500">
                    <SafeIcon icon={FiClock} className="h-4 w-4 mr-1" />
                    {post.readTime}
                  </div>
                </div>
                <h2 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2">
                  {post.title}
                </h2>
                <p className="text-gray-600 mb-4 line-clamp-3">
                  {post.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center text-sm text-gray-500">
                    <SafeIcon icon={FiUser} className="h-4 w-4 mr-1" />
                    {post.date}
                  </div>
                  <Link
                    to={`/blog/${post.id}`}
                    className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium"
                  >
                    Read More
                    <SafeIcon icon={FiArrowRight} className="h-4 w-4 ml-1" />
                  </Link>
                </div>
              </div>
            </motion.article>
          ))}
        </div>

        {/* CTA Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.8 }}
          className="mt-16 bg-blue-600 text-white rounded-lg p-8 text-center"
        >
          <h2 className="text-3xl font-bold mb-4">
            Ready to Protect Your Pet?
          </h2>
          <p className="text-xl text-blue-100 mb-6">
            Get an instant quote and join thousands of California pet owners who trust Nationwide.
          </p>
          <a
            href="https://partnersolutions.nationwide.com/pet/burbankinsuranceservices"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackButtonClick('Blog Page CTA Get Free Quote')}
            className="bg-yellow-500 text-blue-900 px-8 py-4 rounded-lg font-bold text-lg hover:bg-yellow-400 transition-colors inline-block"
          >
            Get Free Quote Now
          </a>
        </motion.div>
      </div>
    </div>
  );
};
export default BlogPage;